import * as React from "react";
import { useTranslation } from "react-i18next";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import { useStoreMap } from "../hooks/useStoreMap";
import StoreMapPanel from "../panel/StoreMapPanel";
import StoreMapMain from "./StoreMapMain";
import ListSuccessMessage from "../../common/layout/ListSuccessMessage";
import StoreMapSettingsPanel from "../panel/StoreMapSettingsPanel";
import ContainerMapModal from "../../containers/modal/ContainerMapModal";

export const StoreMap: React.FC = () => {
    const { t } = useTranslation("admin");
    const {
        receptionPlacePoints,
        receptionPlacePointLocalizations,
        containerPoints,
        allContainerPoints,
        containerPointsLoading,
        receptionPlacePointsLoading,
        internalStorePoints,
        internalStoreBorderPoints,
        internalStorePointsPointsLoading,
        mapType,
        setMapType
    } = useStoreMap();

    return <>
        {
            (containerPointsLoading == false && receptionPlacePointsLoading == false && internalStorePointsPointsLoading == false) ?
                <StoreMapMain
                    receptionPlacePoints={receptionPlacePoints}
                    receptionPlacePointLocalizations={receptionPlacePointLocalizations}
                    containerPoints={containerPoints}
                    allContainerPoints={allContainerPoints}
                    internalStorePoints={internalStorePoints}
                    mapType={mapType}
                    internalStoreBorderPoints={internalStoreBorderPoints}
                />
                :
                <ActivityIndicator text={t("nav.loadingMap") as string} />
        }
        <ListSuccessMessage />
        <StoreMapPanel />
        <StoreMapSettingsPanel mapType={mapType} setMapType={setMapType} />
        <ContainerMapModal />
    </>
}